module.exports = __webpack_public_path__ + "static/5-a164becd23a0e1ffd582b80c57db6ab1.jpeg";